<template>
  <v-container>
    <v-toolbar flat color="white">
      <v-toolbar-title>Bitácora del sistema</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
      <v-spacer></v-spacer>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-dialog v-model="dialog" persistent max-width="800px">
        <v-card>
          <v-card-title>
            <span class="headline">Detalle bitácora</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md4>
                  <v-text-field
                    v-model="editedItem.usuario.username"
                    ref="focustxt"
                    label="Usuario"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4>
                  <v-text-field v-model="editedItem.creado" ref="focustxt" label="Creado"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4>
                  <v-text-field v-model="editedItem.accion" ref="focustxt" label="Acción"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <vue-json-compare
                    :oldData="JSON.parse(editedItem.pre_data)"
                    :newData="JSON.parse(editedItem.post_data)"
                  ></vue-json-compare>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat small color="error" @click="close">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="computedHeaders"
      :items="bitacora"
      :search="search"
      :pagination.sync="pagination"
      :rows-per-page-items="pagination.rowsPerPageItems"
      :total-items="pagination.totalItems"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td v-if="false">{{ props.item.id }}</td>
        <td>{{ props.item.accion }}</td>
        <td>{{ props.item.usuario.username }}</td>
        <td>{{ props.item.creado }}</td>
        <td>{{ props.item.modificado }}</td>
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">info</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Buscar datos de nuevo</v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { debuglog } from "util";
import vueJsonCompare from "vue-json-compare";
export default {
  components: {
    vueJsonCompare
  },
  data: () => ({
    dialog: false,
    deleteDialog: false,
    search: "",
    oldData: {
      a: 1,
      e: 0
    },
    newData: {
      a: 2,
      b: 3
    },
    headers: [
      {
        text: "Id",
        align: "left",
        sortable: true,
        value: "id",
        hidden: true
      },
      {
        text: "Acción",
        align: "left",
        sortable: true,
        value: "accion"
      },
      {
        text: "Usuario",
        align: "left",
        sortable: true,
        value: "usuario.username"
      },
      {
        text: "Creado",
        align: "left",
        sortable: true,
        value: "creado"
      },
      {
        text: "Modificado",
        align: "left",
        sortable: true,
        value: "modificado"
      },
      { text: "Ver", value: "", sortable: false }
    ],
    bitacora: [],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
      rowsPerPageItems: [10]
    },
    editedIndex: -1,
    editedItem: {
      id: null,
      usuario: "",
      accion: "",
      creado: null,
      modificado: null,
      pre_data: null,
      post_data: null
    },
    defaultItem: {
      usuario: "",
      accion: "",
      creado: null,
      modificado: null,
      pre_data: null,
      post_data: null
    }
  }),

  computed: {
    computedHeaders() {
      return this.headers.filter(header => header.text !== "Id");
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    search() {
      this.searchBitacora(this.search);
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      const that = this;
      this.$store
        .dispatch("getBitacora")
        .then(response => {
          setTimeout(function() {
            that.bitacora = that.$store.getters.bitacora;
            that.pagination = that.$store.state.paginationBitacora;
          }, 1000);
        })
        .catch(error => {
          console.log(error);
        });
    },

    editItem(item) {
      this.$refs.focustxt.focus();
      this.editedIndex = this.bitacora.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    searchBitacora(query) {
      const that = this;
      this.$store
        .dispatch("searchBitacora", query)
        .then(response => {
          setTimeout(function() {
            that.bitacora = that.$store.getters.bitacora;
            that.pagination = that.$store.state.paginationBitacora;
          }, 200);
        })
        .catch(error => {
          console.log(error);
        });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    }
  }
};
</script>